export default "__VITE_ASSET__DrHpiPv3__"